//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Drawings.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[[0,"CurrentDrawingSheet",0,"Drawings.DrawingSheet",0]],[[["drawing_name","drawing_units","width","height","numerator","denominator","projection_angle"],"InsertSheet",{R_:{drawing_sheet:"Drawings.DrawingSheet"}},7,1],[["drawing_name","sheet_size","numerator","denominator","projection_angle"],"InsertSheetByPaperSize",{R_:{drawing_sheet:"Drawings.DrawingSheet"}},5,1],[["journal_identifier"],"FindObject",{R_:{sketch:"Drawings.DrawingSheet"}},1,1],[["sheet"],"DrawingSheetBuilder",{R_:{builder:"Drawings.DrawingSheetBuilder"}},1,1],[[],"RefreshCurrentSheet",{},0,0],[["dwgSheets","numPastedDrawingSheets","newPastedDwgSheets"],"PasteDrawingSheets",{},1,0]],[["SheetTemplates","Drawings.SheetTemplateManager",0]]];
SPLM.Drawings.DrawingSheetCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Drawings.DrawingSheetCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;